import styled from 'styled-components';

export const PaginationContainer = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 1.5rem;
    padding: 2rem 0;
    margin-top: 1rem;
`;

export const PageButton = styled.button`
    background: linear-gradient(135deg, #ff6b8b, #6b5bff);
    color: white;
    padding: 0.8rem 1.5rem;
    border: none;
    border-radius: 12px;
    font-size: 1rem;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.3s ease;
    position: relative;
    overflow: hidden;

    &:hover:not(:disabled) {
        transform: translateY(-3px);
        box-shadow: 0 10px 25px rgba(107, 91, 255, 0.4);
    }

    &:disabled {
        opacity: 0.4;
        cursor: not-allowed;
        transform: none;
    }

    &::before {
        content: '';
        position: absolute;
        top: 0;
        left: -100%;
        width: 100%;
        height: 100%;
        background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.2), transparent);
        transition: left 0.5s;
    }

    &:hover:not(:disabled)::before {
        left: 100%;
    }

    @media (max-width: 480px) {
        padding: 0.6rem 1rem;
        font-size: 0.9rem;
    }
`;

export const PageInfo = styled.span`
    color: rgba(255, 255, 255, 0.8);
    font-size: 1rem;
    font-weight: 500;

    @media (max-width: 480px) {
        font-size: 0.85rem;
    }
`;
